var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.appClass,style:({ backgroundColor: _vm.color }),attrs:{"id":"main"}},[_vm._t("default"),_c('div',{attrs:{"id":"notifications"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }